<template>
<div id="app" class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="privacy" :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article id="post-3" class="post-3 page type-page status-publish">
            <div class="inside-article">
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">
                  Privacy Policy
                </h1>
                <span><strong>Effective Date: </strong>May, 2026</span>

              </header>

              <div class="section-content" itemprop="text">
                <p>
                  This policy describes how ogbwhats.com handles information when you read about topics such as <strong>OG WhatsApp download</strong> tips or <strong>OG WhatsApp APK</strong> safety notes.
                  It covers the website—not the WhatsApp service itself, which has separate policies from its publisher.
                </p>

                <h2>What we collect</h2>
                <p>
                  Like many static content sites, we may process technical data your browser already sends: approximate region from IP, device type, browser name, and pages you open here.
                  If you email us, we keep your message only long enough to respond unless law requires otherwise.
                </p>

                <h2>Cookies</h2>
                <p>
                  We or analytics partners may store small cookies to understand traffic patterns—for example, which article sections people finish reading.
                  You can delete or block cookies through your browser; some layout helpers might behave differently afterward.
                </p>

                <h2>How we use information</h2>
                <ul>
                  <li>Improve readability and fix broken links.</li>
                  <li>Measure which guides help readers before they sideload software.</li>
                  <li>Reply to questions about our content—not to provide technical support for third-party APKs.</li>
                </ul>

                <h2>Third-party links</h2>
                <p>
                  Articles may reference download portals or community forums. Their privacy practices are independent; review them before submitting personal data elsewhere.
                </p>

                <h2>Security</h2>
                <p>
                  We apply reasonable safeguards, yet no website can promise perfect security. Treat anything you download from the wider Internet as untrusted until you verify it yourself.
                </p>

                <h2>Children</h2>
                <p>
                  Our guides discuss smartphone software intended for adults who understand sideload risk. We do not knowingly collect information from children.
                </p>

                <h2>Updates</h2>
                <p>
                  We may revise this page when our practices change. Continued browsing after the effective date means you accept the updated version.
                </p>

                <p>
                  Related pages: <router-link to="/about/">About</router-link> · <router-link to="/disclaimer/">Disclaimer</router-link>
                </p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'privacy',

      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },

  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
